/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          window.oRequestAnimationFrame      ||
          window.msRequestAnimationFrame     ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

(function () {

  "use strict";

  var myApp = {

  }

  myApp.init = function() {

    var ticking = false;
    var last_known_scroll_position;
    var headerFixed = $('.navbar-fixed-top');


    ruralApp.Flexslider.initFlex('.flexslider',{animation: 'fade'});
    ruralApp.MagnificPopup.initMagnific('.gallery', {delegate: 'a', type: 'image', gallery: { enabled:true }});


    if (location.pathname == "/app_dev.php/mercados" || location.pathname == "/mercados") {
      var smoothScrollItem = $('.navbar-nav').find('.smooth-scroll');
      smoothScrollItem.off('click', smoothScroll,false);
      smoothScrollItem.on('click', function(event) {
        event.preventDefault();
        window.location = '/' + this.hash;
      });
    } else {
      $('body').scrollspy({ target: '#main-nav', offset: headerFixed.outerHeight(true) });
    }

    $('.gallery-item>a').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      }
    });
  }




  var createLeafletMapModule = function () {
    var map;
    var zoomOut;
    var zoomIn;
    var markers = [];
    var markerImage;

    var infoWindowHTML = '<div class="map-popup">' +
      '<div class="map-popup__title">%infoTitle%</div>' +
      '<div class="map-popup__content">%infoContent%</div>' +
      '</div>';

    var popupOptions = {
      maxWidth: 300,
      minWidth: 220,
      className: 'map-popup-container'
    };

    var getPosition = function (location) {
      return [
        parseFloat(location.lat),
        parseFloat(location.lng)
      ];
    };

    var buildPopupContent = function (info) {
      return infoWindowHTML
        .replace('%infoTitle%', info.title)
        .replace('%infoContent%', info.content);
    };

    var cartoApiKey = 'cb1_340b_1_04d8fba9f90945fb2a55efff';
    var tileLayers = {
      osm: {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        options: {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }
      },
      positron: {
        url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=' + cartoApiKey,
        options: {
          attribution: '&copy; OpenStreetMap &copy; <a href="https://carto.com/attributions">CARTO</a>',
          subdomains: 'abcd',
          maxZoom: 20
        }
      },
      voyager: {
        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=' + cartoApiKey,
        options: {
          attribution: '&copy; OpenStreetMap &copy; <a href="https://carto.com/attributions">CARTO</a>',
          subdomains: 'abcd',
          maxZoom: 20
        }
      },
      dark: {
        url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png?key=' + cartoApiKey,
        options: {
          attribution: '&copy; OpenStreetMap &copy; <a href="https://carto.com/attributions">CARTO</a>',
          subdomains: 'abcd',
          maxZoom: 20
        }
      }
    };

    var getTileLayer = function (styleName) {
      var preset = tileLayers[styleName] || tileLayers.voyager;
      return L.tileLayer(preset.url, preset.options);
    };

    var getMarkerIcon = function (imageUrl, size) {
      var halfWidth = size / 2;

      return L.icon({
        iconUrl: imageUrl,
        iconSize: [size, size],
        iconAnchor: [halfWidth, size],
        popupAnchor: [0, -size]
      });
    };

    var initMap = function (elem, locationsLoaded) {
      var $element = $(elem);

      if ($element.length === 0 || typeof L === 'undefined') {
        return;
      }

      var centerLat = parseFloat($element.attr('data-map-lat') || -32.522779);
      var centerLng = parseFloat($element.attr('data-map-long') || -55.76583500000004);

      zoomOut = parseInt($element.attr('data-map-zoom-out') || 6, 10);
      zoomIn = parseInt($element.attr('data-map-zoom-in') || 15, 10);
      markerImage = $element.attr('data-marker-image') || '/bundles/grupoiterural/img/map-marker.png';
      var markerSize = parseInt($element.attr('data-marker-size') || 50, 10);
      var mapStyle = $element.attr('data-map-style') || 'voyager';

      map = L.map($element.get(0), {
        scrollWheelZoom: false
      }).setView([centerLat, centerLng], zoomOut);

      getTileLayer(mapStyle).addTo(map);

      markers = [];

      locationsLoaded.forEach(function (location) {
        var position = getPosition(location[1]);
        var icon = getMarkerIcon(markerImage, markerSize);
        var marker = L.marker(position, { icon: icon }).addTo(map);
        var popupContent = buildPopupContent(location[2]);

        marker.bindPopup(popupContent, popupOptions);

        marker.on('click', function () {
          map.setView(position, zoomIn);
        });

        markers.push(marker);
      });

      setTimeout(function () {
        map.invalidateSize();
      }, 100);
    };

    return {
      initMap: function (elem, locationsLoaded) {
        initMap(elem, locationsLoaded);
      }
    };
  };

  document.addEventListener('DOMContentLoaded', function() {
    if (window.ruralApp) {
      window.ruralApp.Map = createLeafletMapModule();
    }

    myApp.init();
  }, false);

})();
